import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import { useLanguage } from "../../context/LanguageContext";
import musicPlayer from "../../Assets/Projects/musicPlayer.png";
import search from "../../Assets/Projects/search.png";
import lena from "../../Assets/Projects/lena.png";
import tiket4t from "../../Assets/Projects/ticket4t.png";
import monitor from "../../Assets/Projects/monitor.png";
import slangword from "../../Assets/Projects/slangword.png";
import codeDocsSite from "../../Assets/Projects/codeDocsSite.png";
import airiPaperBlog from "../../Assets/Projects/airiPaperBlog.png";
import basicToolsWeb from "../../Assets/Projects/basicToolsWeb.png";
import shimejiUbuntu from "../../Assets/Projects/shimejiUbuntu.png";
import tichCongDuc from "../../Assets/Projects/tichCongDuc.png";
// import vnetraffic from "../../Assets/Projects/vnetraffic.png";
import officeHub from "../../Assets/Projects/officeHub.png";
import tiDownloader from "../../Assets/Projects/tiDownloader.png";
import tiMap from "../../Assets/Projects/tiMap.jpg";
import tiGame from "../../Assets/Projects/tiGame.png";
import sapTet from "../../Assets/Projects/sapTet.jpg";

const ALL_PROJECTS = [
  {
    imgPath: officeHub,
    isBlog: false,
    title: "Ti Office",
    subject: {
      en: "Smart Office Management Platform",
      vi: "Nền tảng Quản lý Văn phòng Thông minh",
    },
    category: "Web",
    description: {
      en: "A smart office management platform that centralizes workspace operations, including task scheduling, team coordination, document handling, and meeting management — designed for productivity and seamless collaboration.",
      vi: "Nền tảng quản lý văn phòng thông minh giúp tập trung các hoạt động làm việc bao gồm lập lịch công việc, phối hợp nhóm, xử lý tài liệu và quản lý cuộc họp — thiết kế tối ưu hiệu suất và cộng tác mượt mà.",
    },
    demoLink: "https://tihub-office.vercel.app/",
    screenshots: [
      process.env.PUBLIC_URL + "/screenshots/office-hub/office-1-dashboard.png",
      process.env.PUBLIC_URL + "/screenshots/office-hub/office-2-operations.png",
    ],
  },
  {
    imgPath: basicToolsWeb,
    isBlog: false,
    title: "Ti Tools",
    subject: {
      en: "Developer & Document Utility Workspace",
      vi: "Bộ công cụ Lập trình viên & Xử lý Tài liệu",
    },
    category: "Web",
    description: {
      en: "A privacy-first browser workspace with 20+ developer and document utilities, including JWT Debugger, QR Studio, Excel to PDF, editable PDF to Word, PDF tools, image compression, and Vietnamese OCR.",
      vi: "Không gian làm việc bảo mật trên trình duyệt tích hợp hơn 20 công cụ lập trình và xử lý tài liệu, gồm JWT Debugger, QR Studio, chuyển Excel sang PDF, PDF sang Word chỉnh sửa, công cụ PDF, nén ảnh và OCR tiếng Việt.",
    },
    demoLink: "https://airi-tools.vercel.app/",
    screenshots: [
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-01-hub.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-02.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-03.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-04.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-05.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-06.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-07.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-08.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-09.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-10.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-11.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-12.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-13.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-14.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-15.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-16.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-17.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-18.png",
      process.env.PUBLIC_URL + "/screenshots/ti-tools/tool-19.png",
    ],
  },
  {
    imgPath: tiMap,
    isBlog: false,
    title: "Ti Map",
    subject: {
      en: "Traffic Camera & Map Portal",
      vi: "Cổng Giao thông & Camera Trực tiếp TP.HCM",
    },
    category: "Web",
    description: {
      en: "A real-time map and traffic camera portal for Ho Chi Minh City key intersections with a modern claymorphism interface, live camera feeds, 2x2/3x3 multi-grid views, and smart navigation features.",
      vi: "Cổng bản đồ và camera giao thông thời gian thực tại các nút giao trọng điểm TP.HCM với giao diện Claymorphism hiện đại, luồng camera trực tiếp, xem lưới 2x2/3x3 và điều hướng thông minh.",
    },
    demoLink: "https://ti-map.vercel.app/",
    screenshots: [
      process.env.PUBLIC_URL + "/screenshots/ti-map/timap-1-portal.png",
      process.env.PUBLIC_URL + "/screenshots/ti-map/timap-2-grid-2x2.png",
      process.env.PUBLIC_URL + "/screenshots/ti-map/timap-3-grid-3x3.png",
      process.env.PUBLIC_URL + "/screenshots/ti-map/timap-4-live-camera.png",
    ],
  },
  {
    imgPath: tiGame,
    isBlog: false,
    title: "Ti Game",
    subject: {
      en: "Web HTML5 Gaming Platform",
      vi: "Nền tảng Trò chơi Web HTML5",
    },
    category: "Web",
    description: {
      en: "A modern web gaming platform featuring instant HTML5 games across multiple genres (Space Shooter, Neon Racer, Harvest Valley, Gomoku), local offline save, daily rewards, leaderboards, and responsive gameplay with zero install required.",
      vi: "Cổng trò chơi web hiện đại với kho game HTML5 chơi ngay tức thì đa thể loại (Space Shooter, Neon Racer, Harvest Valley, Cờ Caro), lưu dữ liệu offline, phần thưởng điểm danh hàng ngày, bảng xếp hạng và giao diện tối ưu đa thiết bị.",
    },
    techStack: ["React", "HTML5 Canvas", "Tailwind CSS", "JavaScript", "Vercel"],
    demoLink: "https://ti-game.vercel.app/",
    screenshots: [
      process.env.PUBLIC_URL + "/screenshots/ti-game/game-1-hub.png",
      process.env.PUBLIC_URL + "/screenshots/ti-game/game-2-space-shooter.png",
      process.env.PUBLIC_URL + "/screenshots/ti-game/game-3-leaderboard.png",
    ],
  },
  /*
  {
    imgPath: vnetraffic,
    isBlog: false,
    title: "VneTraffic",
    subject: {
      en: "Smart Traffic System",
      vi: "Hệ thống Giao thông Thông minh",
    },
    category: "Java",
    description: {
      en: "A smart national-scale traffic monitoring and management system. Built with secure microservices using Java/Spring Boot and real-time Kafka pipelines to handle high-throughput telemetry, live sensor data, and speed metrics.",
      vi: "Hệ thống quản lý và giám sát giao thông thông minh quy mô quốc gia. Được xây dựng trên kiến trúc microservices bảo mật với Java/Spring Boot và các luồng dữ liệu thời gian thực xử lý lưu lượng lớn.",
    },
    techStack: ["Java", "Spring Boot", "Kafka", "Microservices"],
    playStoreLink:
      "https://play.google.com/store/apps/details?id=com.ots.c08.vnetraffic&hl=vi",
    appStoreLink: "https://apps.apple.com/vn/app/vnetraffic/id6475181815",
  },
  */
  {
    imgPath: shimejiUbuntu,
    isBlog: false,
    title: "Shimeji Ubuntu",
    subject: {
      en: "Desktop Mascot Customization",
      vi: "Tùy chỉnh Mascot Tương tác trên Desktop",
    },
    category: "Desktop",
    description: {
      en: "A desktop customization project that brings interactive companion characters to Ubuntu desktop environment with smooth animations and user actions.",
      vi: "Dự án tùy chỉnh desktop mang các nhân vật tương tác ngộ nghĩnh lên môi trường Ubuntu với chuyển động mượt mà và phản hồi thao tác người dùng.",
    },
    techStack: ["C++", "Qt", "Linux"],
    ghLink: "https://github.com/ngoc-thu/shimeji-ubuntu",
    downloadLink: "https://github.com/ngoc-thu/shimeji-ubuntu/releases/tag/v1.0.0",
  },
  {
    imgPath: tiDownloader,
    isBlog: false,
    title: "Ti Downloader",
    subject: {
      en: "Online Media & Video Downloader Workspace",
      vi: "Công cụ Tải Video & Media Trực tuyến",
    },
    category: "Web",
    description: {
      en: "A fast and clean online media downloader tool allowing users to extract high-quality video and audio content effortlessly with a smooth user experience.",
      vi: "Công cụ tải media trực tuyến nhanh chóng và gọn gàng, hỗ trợ tách tải video và audio chất lượng cao dễ dàng với trải nghiệm người dùng mượt mà.",
    },
    demoLink: "https://ti-downloader-web.vercel.app/",
    screenshots: [
      process.env.PUBLIC_URL + "/screenshots/ti-downloader/desktop-1.png",
      process.env.PUBLIC_URL + "/screenshots/ti-downloader/desktop-2.png",
      process.env.PUBLIC_URL + "/screenshots/ti-downloader/desktop-3.png",
    ],
  },
  {
    imgPath: codeDocsSite,
    isBlog: false,
    title: "Ti Code Docs",
    subject: {
      en: "Documentation Website Development",
      vi: "Trang Tài liệu Kỹ thuật & Tra cứu Code",
    },
    category: "Web",
    description: {
      en: "A developer-focused documentation website that organizes coding knowledge into a clean, easy-to-navigate experience with clear structure for learning, reference, and quick lookup.",
      vi: "Trang web tài liệu dành cho lập trình viên sắp xếp kiến thức code gọn gàng, dễ điều hướng với cấu trúc rõ ràng cho học tập, tham khảo và tra cứu nhanh.",
    },
    techStack: ["React", "JavaScript", "Vercel"],
    demoLink: "https://code-docs-site.vercel.app/",
    screenshots: [
      process.env.PUBLIC_URL + "/screenshots/ti-code-docs/desktop-1.png",
      process.env.PUBLIC_URL + "/screenshots/ti-code-docs/desktop-2.png",
      process.env.PUBLIC_URL + "/screenshots/ti-code-docs/desktop-3.png",
    ],
  },
  {
    imgPath: airiPaperBlog,
    isBlog: false,
    title: "Ti Paper Blog",
    subject: {
      en: "AI & Paper Research Blog",
      vi: "Blog Nghiên cứu Bài báo & Công nghệ AI",
    },
    category: "Web",
    description: {
      en: "A blog-style web application that presents AI and research-related content in a clean, modern interface with online deployment for easy access and sharing.",
      vi: "Ứng dụng web dạng blog trình bày nội dung nghiên cứu AI và bài báo khoa học trên giao diện hiện đại, sạch sẽ giúp dễ dàng truy cập và chia sẻ.",
    },
    techStack: ["Astro", "Tailwind CSS", "MDX"],
    demoLink: "https://airi-bot-paper-blog.vercel.app/",
    screenshots: [
      process.env.PUBLIC_URL + "/screenshots/ti-paper-blog/desktop-1.png",
      process.env.PUBLIC_URL + "/screenshots/ti-paper-blog/desktop-2.png",
      process.env.PUBLIC_URL + "/screenshots/ti-paper-blog/desktop-3.png",
    ],
  },
  {
    imgPath: tichCongDuc,
    isBlog: false,
    title: "Gõ Mõ Online 3D",
    subject: {
      en: "Entertainment Web Application",
      vi: "Ứng dụng Giải trí Gõ Mõ 3D Trực tuyến",
    },
    category: "Web",
    description: {
      en: "A 3D interactive Wooden Fish tapping application designed for stress relief. Built with Three.js for smooth 3D rendering and Firebase for real-time leaderboards, user auth, combo counts, and community donations.",
      vi: "Ứng dụng gõ mõ 3D tương tác giải tỏa căng thẳng. Xây dựng bằng Three.js cho đồ họa 3D mượt mà và Firebase cho bảng xếp hạng thời gian thực, đăng nhập, đếm combo và tích công đức.",
    },
    techStack: ["Three.js", "Firebase", "WebGL", "JavaScript"],
    demoLink: "https://tich-cong-duc.vercel.app/",
    screenshots: [
      process.env.PUBLIC_URL + "/screenshots/go-mo-3d/desktop-1.png",
      process.env.PUBLIC_URL + "/screenshots/go-mo-3d/desktop-2.png",
      process.env.PUBLIC_URL + "/screenshots/go-mo-3d/desktop-3.png",
    ],
  },
  {
    imgPath: sapTet,
    isBlog: false,
    title: "Sắp Tết",
    subject: {
      en: "Lunar New Year Countdown & Cultural Utilities",
      vi: "Ứng dụng Đếm ngược & Tiện ích Văn hóa Đón Tết",
    },
    category: "Web",
    description: {
      en: "A Lunar New Year countdown and interactive traditional Vietnamese holiday web application. Features live countdown, lunar-solar calendar converter, calligraphy, fortune drawing, holiday wishes, and festive music.",
      vi: "Ứng dụng đếm ngược Tết và trải nghiệm văn hóa truyền thống Việt Nam. Tích hợp đếm ngược thời gian thực, chuyển đổi lịch âm dương, xin chữ thầy đồ, gieo quẻ xăm, lời chúc và âm nhạc ngày Tết.",
    },
    techStack: ["React", "Tailwind CSS", "JavaScript", "Vercel"],
    demoLink: "https://sap-tet.vercel.app/",
    screenshots: [
      process.env.PUBLIC_URL + "/screenshots/sap-tet/saptet-1-countdown.png",
      process.env.PUBLIC_URL + "/screenshots/sap-tet/saptet-2-gieo-que.png",
      process.env.PUBLIC_URL + "/screenshots/sap-tet/saptet-3-xin-chu.png",
      process.env.PUBLIC_URL + "/screenshots/sap-tet/saptet-4-theme-mai.png",
      process.env.PUBLIC_URL + "/screenshots/sap-tet/saptet-5-phao-hoa.png",
    ],
  },
  {
    imgPath: tiket4t,
    isBlog: false,
    title: "Ticket4T",
    subject: {
      en: "Web Application Development",
      vi: "Hệ thống Đặt vé Trực tuyến",
    },
    category: "Web",
    description: {
      en: "Ticket4T is an online ticket booking platform designed to provide users with a smooth, convenient, and user-friendly reservation experience.",
      vi: "Ticket4T là nền tảng đặt vé trực tuyến thiết kế mang lại trải nghiệm đặt chỗ mượt mà, tiện lợi và thân thiện với người dùng.",
    },
    techStack: ["React", "Express", "PostgreSQL"],
    ghLink: "https://github.com/NgocTien0110/Ticket4T",
    demoLink: "https://project-ticket4t-nhom5.onrender.com/",
  },
  {
    imgPath: slangword,
    isBlog: false,
    title: "Slang Word",
    subject: {
      en: "Java Desktop Application",
      vi: "Từ điển Slang Word Tiếng Anh",
    },
    category: "Java",
    description: {
      en: "A Java Swing desktop application for searching, managing, and practicing English slang words with search history, random word of the day, and quiz games.",
      vi: "Ứng dụng Java Swing tra cứu, quản lý và luyện tập tiếng lóng (Slang Word) với lịch sử tìm kiếm, từ ngẫu nhiên mỗi ngày và trò chơi trắc nghiệm.",
    },
    techStack: ["Java", "Java Swing", "OOP"],
    ghLink: "https://github.com/NgocTien0110/Slang-Dictionary",
    demoLink: "https://www.youtube.com/watch?v=k96VdcADKXY",
  },
  {
    imgPath: monitor,
    isBlog: false,
    title: "Client Monitoring System",
    subject: {
      en: "Java Application Development",
      vi: "Hệ thống Giám sát Client qua Mạng",
    },
    category: "Java",
    description: {
      en: "A Java desktop application for monitoring client-side file directories, combining a graphical interface, network communication, and multithreading to deliver efficient real-time tracking.",
      vi: "Ứng dụng Java desktop giám sát thư mục và tệp tin phía máy client, kết hợp giao diện đồ họa, truyền thông mạng socket và đa luồng để theo dõi thời gian thực hiệu quả.",
    },
    techStack: ["Java", "Socket", "Multithreading"],
    ghLink: "https://github.com/NgocTien0110/A-CLIENT-MONITORING-SYSTEM",
    demoLink: "https://www.youtube.com/watch?v=2aAT5BzWeL8&t=2s",
  },
  {
    imgPath: search,
    isBlog: false,
    title: "Search Algorithms",
    subject: {
      en: "Introduction to Artificial Intelligence",
      vi: "Mô phỏng Thuật toán Tìm kiếm Trí tuệ Nhân tạo",
    },
    category: "AI / ML",
    description: {
      en: "A simulation project that visualizes classic AI search algorithms including BFS, UCS, IDS, A* Search, and Greedy Best-First Search in maze-solving scenarios.",
      vi: "Dự án mô phỏng trực quan hóa các thuật toán tìm kiếm AI kinh điển gồm BFS, UCS, IDS, A* Search và Greedy Best-First Search trong bài toán giải mê cung.",
    },
    techStack: ["Python", "AI", "Algorithms"],
    ghLink: "https://github.com/NgocTien0110/Artificial-Intelligence-Lab-1",
  },
  {
    imgPath: musicPlayer,
    isBlog: false,
    title: "Music Player",
    subject: {
      en: "Introduction to Software Engineering",
      vi: "Trình phát Nhạc Trực tuyến",
    },
    category: "Web",
    description: {
      en: "A music streaming website with essential playback features such as play/pause, volume control, playlist creation, and shuffle mode, using music sourced from ZingMP3.",
      vi: "Trang web phát nhạc trực tuyến với các tính năng cơ bản như phát/tạm dừng, chỉnh âm lượng, tạo danh sách phát và chế độ phát ngẫu nhiên từ nguồn ZingMP3.",
    },
    techStack: ["HTML", "CSS", "JavaScript"],
    ghLink: "https://github.com/ntp-shin/Music_Player_Group5",
  },
  {
    imgPath: lena,
    isBlog: false,
    title: "Image Processing",
    subject: {
      en: "Applied Mathematics and Statistics",
      vi: "Xử lý Ảnh Số & Toán Ứng dụng",
    },
    category: "AI / ML",
    description: {
      en: "An image processing project featuring fundamental operations such as brightness and contrast adjustment, image flipping, grayscale conversion, blending, blurring, and shape-based masking.",
      vi: "Dự án xử lý ảnh số gồm các thao tác cơ bản như chỉnh độ sáng/tương phản, lật ảnh, chuyển ảnh xám, hòa trộn, làm mờ và tạo mặt nạ theo hình dạng.",
    },
    techStack: ["Python", "NumPy", "Matplotlib"],
    ghLink:
      "https://github.com/NgocTien0110/Applied-Mathematics-and-Statistics/tree/main/lab3_project2",
  },
];

function Projects() {
  const { language, t } = useLanguage();
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          {t.projects.title} <strong className="purple">{t.projects.titleHighlight}</strong>
        </h1>
        <p className="project-section-subtitle">
          {t.projects.subtitle}
        </p>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {ALL_PROJECTS.map((project, idx) => {
            const subj =
              typeof project.subject === "object"
                ? project.subject[language] || project.subject.en
                : project.subject;
            const desc =
              typeof project.description === "object"
                ? project.description[language] || project.description.en
                : project.description;
            return (
              <Col key={idx} md={4} className="project-card">
                <ProjectCard
                  {...project}
                  subject={subj}
                  description={desc}
                />
              </Col>
            );
          })}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
